/**
 * Phone helpers for the Communications channels. Lets users enter local SA numbers
 * (e.g. 0794559874) which are converted to international format (+27…) before send.
 */

/**
 * Convert a local / SA number to international E.164 (with leading '+'):
 *   0794559874   → +27794559874   (0 trunk prefix → 27 country code)
 *   794559874    → +27794559874   (bare 9-digit local → assume SA)
 *   27794559874  → +27794559874
 *   +27 79 455 9874 → +27794559874
 *   447911123456 → +447911123456  (already has another country code → left as-is)
 * Returns '' for empty input.
 */
export function toInternational(raw?: string | null): string {
  let d = (raw || '').replace(/\D/g, '');
  if (!d) return '';
  if (d.startsWith('0')) d = '27' + d.slice(1);
  else if (d.length === 9) d = '27' + d; // bare SA local without trunk prefix
  return '+' + d;
}

/** Accept local, bare-local, or international input; validate the normalized form. */
export function isValidPhone(raw?: string | null): boolean {
  const intl = toInternational(raw).replace('+', '');
  return intl.length >= 10 && intl.length <= 15;
}
